import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import {RecentItemModel} from "./recent-item.model";
import {LocalStorageService} from "../../../../../../service/services/misc/local-storage/local-storage.service";
import {formatDate} from "@angular/common";

@Component({
    selector: 'app-recent-list',
    templateUrl: './recent-list.component.html',
    styleUrls: ['./recent-list.component.scss'],
    standalone: false
})
export class RecentListComponent implements OnInit, OnDestroy {

    @Input() path: string;
    @Input() pathEnteredEvent: Observable<string>;
    @Output() recentItemClicked: EventEmitter<RecentItemModel> = new EventEmitter<RecentItemModel>();

    private pathEnteredSubscription: Subscription;

    showMore = false;
    showMoreLessText = this.showMorOrLessText();

    storedItems : RecentItemModel[] = [];

    initialNumberOfItems = 3;
    maxItemsToShow = 12;

    RECENT_ITEMS_KEY = "recent-items";

    constructor(private _localStorageService: LocalStorageService) {}

    ngOnInit() {
        this.storedItems = JSON.parse(this._getStoredItems()) || [];
        this.pathEnteredSubscription = this.pathEnteredEvent.subscribe((path) => this.onPathEntered(path));
    }
    ngOnDestroy() {
        this.pathEnteredSubscription.unsubscribe();
    }
    onPathEntered(path: string, dateTime?: string) {
        //Add to localstorage
        const currentDateTime = dateTime ? dateTime : formatDate(new Date(), 'dd-MMM-yy HH:mm:ss', 'en-US');
        const recentItemModel = new RecentItemModel(currentDateTime, path);
        const recentItems: RecentItemModel[] = JSON.parse(this._localStorageService.get(this.RECENT_ITEMS_KEY)) || [];
        const recentItem = recentItems.find(recentItem => recentItem.path === path);
        if (recentItem) {
            recentItem.lastVisited = currentDateTime;
        } else {
            // Check if the array has reached the limit of 100 items
            if (recentItems.length >= 100) {
                // Remove the oldest item (first item in the array)
                recentItems.shift();
            }
            recentItems.push(recentItemModel);
        }

        this._localStorageService.set(this.RECENT_ITEMS_KEY, JSON.stringify(recentItems));
        this.storedItems = recentItems;
    }
    public resetListComponent() {
        this.showMore = false;
        this.showMoreLessText = this.showMorOrLessText();
    }

    clickOnItem(item: RecentItemModel) {
        this.recentItemClicked.emit(item);
    }
    showMoreToggle() {
        this.showMore = !this.showMore;
        this.showMoreLessText = this.showMorOrLessText();
    }
    showMorOrLessText() {
        //TODO: how to use localize?
        // return this.showMore ?
        //     $localize`:XBTN|Button Name input@@recentList.showLess:Show less` :
        //     $localize`:XBTN|Button Name input@@recentList.showMore $SHOW_MORE`;
        return this.showMore ? 'Show Less' : 'Show More';
    }
    private _getStoredItems() {
        const storage = this._localStorageService.getLocalStorage();
        return storage.getItem(this.RECENT_ITEMS_KEY);
    }
}
